import type { ThemeConfig } from "../types";
import { CottonCandyScene } from "./Scene";

export const auroraDrift: ThemeConfig = {
  id: "aurora-drift",
  name: "Cotton Candy",
  tagline: "Pastel sky, fluffy clouds, kawaii unicorn",
  brandLabel: "Cotton Candy",
  tokens: {
    bg: "#2a0e4a",
    bgElevated: "rgba(255, 255, 255, 0.06)",
    bgPanel: "rgba(40, 18, 60, 0.78)",
    bgOverlay: "rgba(20, 8, 40, 0.86)",

    fg: "#fff8fa",
    fgMuted: "rgba(255, 230, 240, 0.6)",
    fgStrong: "#ffffff",
    fgInverse: "#2a0e4a",

    accent: "#ff6b9d",
    accentSoft: "rgba(255, 107, 157, 0.18)",
    accent2: "#7bd685",
    accent2Soft: "rgba(123, 214, 133, 0.18)",
    accentRainbow:
      "linear-gradient(90deg, #ff6b9d 0%, #ff9c4a 17%, #ffd23f 34%, #7bd685 50%, #4ec5ff 67%, #b88aff 84%, #ff6b9d 100%)",

    border: "rgba(255, 107, 157, 0.28)",
    borderSoft: "rgba(255, 255, 255, 0.08)",
    borderStrong: "rgba(255, 107, 157, 0.5)",

    positive: "#7bd685",
    negative: "#ff5577",
    warning: "#ffd23f",

    bankPanelBg:
      "linear-gradient(180deg, rgba(80, 30, 90, 0.86) 0%, rgba(40, 18, 60, 0.86) 100%)",
    bankPanelBorder: "rgba(255, 107, 157, 0.42)",
    bankPanelHeading: "#ff6b9d",

    fontDisplay: "'Space Grotesk', 'Inter Display', 'Inter', system-ui, sans-serif",
    fontBody: "'Inter', system-ui, sans-serif",
    fontMono: "'JetBrains Mono', 'DM Mono', ui-monospace, monospace",

    decorationGlow: "0 0 24px rgba(255, 107, 157, 0.45)"
  },
  assets: {
    mascot: "scene:cotton-candy",
    decorations: [],
    Scene: CottonCandyScene
  }
};
